'use strict';
const raceAgainstTimeout = require('./race-against-timeout');
module.exports = function GapiScriptLoader(config, gapiContainer, navigatorShim) {
	let scriptTag = false;
	const self = this,
		timeout = config.scriptLoadingTimeout || 15000,
		gapiLoaded = function () {
			return !!(
				gapiContainer.gapi && gapiContainer.gapi.load && typeof gapiContainer.gapi.load === 'function'
			);
		},
		ensureGapi = function () {
			if (gapiLoaded()) {
				return Promise.resolve();
			} else {
				return new Promise(function (resolve, reject) {
					const scriptsLoadComplete = function () {
						if (gapiLoaded()) {
							resolve();
						} else {
							reject('network-error');
						}
					};
					if (scriptTag) {
						scriptTag.remove();
						scriptTag = false;
					}
					gapiContainer.initGoogleAPI = scriptsLoadComplete;
					scriptTag = navigatorShim.loadScript('https://apis.google.com/js/api.js?onload=initGoogleAPI');
				});
			}
		};
	self.ensureEditorScripts = async function () {
		const loaded = function () {
			return (gapiContainer.gapi && gapiContainer.gapi.drive && gapiContainer.gapi.drive.share &&
					gapiContainer.google && gapiContainer.google.picker);
		};
		if (loaded()) {
			return true;
		}
		return raceAgainstTimeout(
			navigatorShim,
			ensureGapi().then(() =>
				new Promise((resolve, reject) => {
					gapiContainer.gapi.load('drive-share:picker', {
						callback: () => {
							if (loaded()) {
								resolve();
							} else {
								reject('script-loading-failed');
							}
						},
						onerror: reject,
						timeout: timeout,
						ontimeout: reject
					});
				})
			),
			timeout
		);
	};
	self.buildShareClient = function () {
		return new gapiContainer.gapi.drive.share.ShareClient(config.googleAppId);
	};
};
